import type {
  InsuranceOffer,
  InsuranceOfferWithSelectedState,
} from '@backmarket/http-api/src/api-models/InsuranceOffer'

export function hasOfferCompliancyError(
  insuranceOffer: InsuranceOfferWithSelectedState,
) {
  return (
    insuranceOffer.selected &&
    insuranceOffer.compliancy.isUserAgreementRequired &&
    !insuranceOffer.compliancy.isUserAgreementAccepted
  )
}

export function getOfferWithoutSelectedState(
  insuranceOffer?: InsuranceOfferWithSelectedState,
): InsuranceOffer | null {
  if (insuranceOffer) {
    const { selected: _selected, ...offerWithoutSelectedState } = insuranceOffer

    return offerWithoutSelectedState
  }

  return null
}
